/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  OptOutRequestBase,
  OptOutRequestBaseOptional,
  OptOutRequestBaseMetaI,
  OptOutRequestBaseTrackedI,
} from "./opt-out-request-base";
import {
  OptOutRequestBaseTracked,
  OptOutRequestBaseMeta,
} from "./opt-out-request-base";

/**
 *
 * @export
 * @interface UpdateOptOutDTO
 */
export interface UpdateOptOutDTOOptional extends OptOutRequestBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof UpdateOptOutDTO
   */
  doNotSend?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateOptOutDTO
   */
  token?: string;
}

export interface UpdateOptOutDTO
  extends UpdateOptOutDTOOptional, OptOutRequestBase {
  /**
   *
   * @type {boolean}
   * @memberof UpdateOptOutDTO
   */
  doNotSend?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateOptOutDTO
   */
  token?: string;
}

export interface UpdateOptOutDTOTrackedI extends OptOutRequestBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof UpdateOptOutDTO
   */
  doNotSend?: boolean;
  doNotSendIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateOptOutDTO
   */
  token?: string;
  tokenIsSet: boolean;
}

transformDatesMap.set("UpdateOptOutDTO", function (model: UpdateOptOutDTO) {});

export type UpdateOptOutDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  doNotSend: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  token: PropertyMeta<MetaTypeBase<string>>;
}>;

export var UpdateOptOutDTOMeta: UpdateOptOutDTOMetaI =
  {} as UpdateOptOutDTOMetaI;
UpdateOptOutDTOMeta = typeMeta("UpdateOptOutDTO", {
  doNotSend: propertyMeta(
    "doNotSend",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  token: propertyMeta("token", false, false, false, MetaTypesBase.string),
});

const metaI = UpdateOptOutDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([OptOutRequestBaseMeta]);
  metaI.doNotSend.inheritedFrom = OptOutRequestBaseMeta.doNotSend;
  metaI.token.inheritedFrom = OptOutRequestBaseMeta.token;
});

export class UpdateOptOutDTOTracked
  extends OptOutRequestBaseTracked
  implements UpdateOptOutDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  doNotSend__I?: boolean = undefined;
  doNotSendIsSet: boolean = false;
  set doNotSend(v: undefined | boolean) {
    if (v !== undefined) {
      this.doNotSend__I = v;
      this.doNotSendIsSet = true;
    } else {
      this.doNotSend__I = v || undefined;
      this.doNotSendIsSet = false;
    }
    this.changeTracker = true;
  }
  get doNotSend() {
    return this.doNotSend__I;
  }
  token__I?: string = undefined;
  tokenIsSet: boolean = false;
  set token(v: undefined | string) {
    if (v !== undefined) {
      this.token__I = v;
      this.tokenIsSet = true;
    } else {
      this.token__I = v || undefined;
      this.tokenIsSet = false;
    }
    this.changeTracker = true;
  }
  get token() {
    return this.token__I;
  }
  constructor(config?: UpdateOptOutDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: UpdateOptOutDTOOptional,
    options?: AssignOptions,
  ): UpdateOptOutDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.doNotSend && this.doNotSendApplyFilter(optionsRequired.filter)) {
      this.doNotSend = config.doNotSend;
      if (optionsRequired.unassign) this.doNotSendIsSet = false;
      else this.doNotSendIsSet = true;
    }
    if (config.token && this.tokenApplyFilter(optionsRequired.filter)) {
      this.token = config.token;
      if (optionsRequired.unassign) this.tokenIsSet = false;
      else this.tokenIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): UpdateOptOutDTOTrackedI {
    const cloned = {} as UpdateOptOutDTOTrackedI;
    if (
      this.doNotSendIsSetDeep() &&
      this.doNotSendApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.doNotSendIsSet = true;
      cloned.doNotSend = this.doNotSend;
    } else {
      //cloned.doNotSendIsSet = false
    }
    if (
      this.tokenIsSetDeep() &&
      this.tokenApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tokenIsSet = true;
      cloned.token = this.token;
    } else {
      //cloned.tokenIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): UpdateOptOutDTOTrackedI {
    if (!this.doNotSendApplyFilter(filter)) this.doNotSendIsSet = false;

    if (!this.tokenApplyFilter(filter)) this.tokenIsSet = false;

    return this;
  }
  doNotSendApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UpdateOptOutDTOMeta.doNotSend,
      UpdateOptOutDTOMeta,
      this.doNotSend,
      this,
    );
  }
  doNotSendIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.doNotSendIsSet && this.doNotSendApplyFilter(filter)) return true;

    return false;
  }
  tokenApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UpdateOptOutDTOMeta.token,
      UpdateOptOutDTOMeta,
      this.token,
      this,
    );
  }
  tokenIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tokenIsSet && this.tokenApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.doNotSendIsSetDeep(filter)) return true;
    if (this.tokenIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
